'use client';
import { FC, useEffect, useState } from 'react';

import { DateType } from '@utils/dateUtil';
import {
  Arrow,
  ErrorMessageContainer,
  ErrorMessage,
} from '@domain/hotel/styled';
import useSearchBar from '@contexts/searchbar';
import { HotelSearchBarActionType } from '@contexts/searchbar/types/hotel';

import HotelBookerDatePicker from './HotelBookerDatePicker';
import { resolveHotelSearchRangeOnApply } from './resolveHotelSearchRangeOnApply';
import { Container } from './styled';

export type DateDataTypes = {
  startDate: DateType;
  endDate: DateType;
};

const DateSelection: FC<{ isTravelPlanning?: boolean }> = ({
  isTravelPlanning,
}) => {
  const {
    state: { hotel: state },
    dispatch,
  } = useSearchBar();

  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    state.checkDates?.startDate || null
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(
    state.checkDates?.endDate || null
  );

  useEffect(() => {
    if (state.checkDates?.startDate) {
      setLocalStartDate(state.checkDates.startDate);
    }

    if (state.checkDates?.endDate) {
      setLocalEndDate(state.checkDates.endDate);
    }
  }, [state.checkDates]);

  const onDatesChange = (dates?: {
    startDate?: DateType | null;
    endDate?: DateType | null;
  }) => {
    setLocalStartDate(dates?.startDate as DateType);
    setLocalEndDate(dates?.endDate as DateType);

    if (dates?.startDate && dates?.endDate) {
      dispatch({
        type: HotelSearchBarActionType.SET_CHECK_DATES,
        payload: { startDate: dates.startDate, endDate: dates.endDate },
      });
      state.isCheckDatesError &&
        dispatch({
          type: HotelSearchBarActionType.SET_IS_CHECK_DATES_ERROR,
          payload: false,
        });
    }
  };

  const handleFocus = () => {
    dispatch({
      type: HotelSearchBarActionType.SET_IS_CHECK_DATES_ERROR,
      payload: false,
    });
  };

  const handleBlur = () => {
    dispatch({
      type: HotelSearchBarActionType.SET_IS_CHECK_DATES_ERROR,
      payload: false,
    });
  };

  return (
    <Container>
      <HotelBookerDatePicker
        dateChange={onDatesChange}
        setLocalEndDate={setLocalEndDate}
        setLocalStartDate={setLocalStartDate}
        localStartDate={localStartDate}
        localEndDate={localEndDate}
        onFocus={handleFocus}
        onBlur={handleBlur}
        isErrorDateSelection={state.isCheckDatesError}
        isTravelPlanning={isTravelPlanning}
        resolveRangeOnApply={resolveHotelSearchRangeOnApply}
      />
      {state.isCheckDatesError && (
        <ErrorMessageContainer>
          <Arrow />
          <ErrorMessage>Tarih seçiniz</ErrorMessage>
        </ErrorMessageContainer>
      )}
    </Container>
  );
};

export default DateSelection;
